import React, { useEffect } from "react";
import Avatar from "../../../images/contactlogo.svg";
import Close from "../../../images/Close.svg";
import { useLazyQuery } from "@apollo/client";
import {
  GetTransformEmpDetailsResult,
  GetTransformEmpDetailsVar,
} from "./queries/types";
import { GetTransformEmpDetails } from "./queries/queries";

interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const Profile = ({ setModal }: Props) => {
  const [getTransformEmpDetails, { data, loading }] = useLazyQuery<
    GetTransformEmpDetailsResult,
    GetTransformEmpDetailsVar
  >(GetTransformEmpDetails);

  useEffect(() => {
    getTransformEmpDetails();
  }, [getTransformEmpDetails]);

  return (
    <>
      <div className=" ms-auto">
        <img
          src={Close}
          alt="/"
          onClick={() => {
            setModal(false);
          }}
         style={{filter: "invert(100%)"}}
        />
      </div>
      <div className="d-flex flex-column justify-content-center">
        <div>
          <div>
            <img
              src={Avatar}
              alt=""
              onClick={() => {
                setModal(true);
              }}
            />
          </div>
          <b className="text-light">{data?.GetTransformEmpDetails.name}</b>
        </div>

        <div className="text-light d-flex flex-column">
          <b>Designation : {data?.GetTransformEmpDetails.empType}</b>
          <b>KGID : {data?.GetTransformEmpDetails.kgid}</b>
        </div>
      </div>
    </>
  );
};

export default Profile;
